export default import.meta.ROLLUP_FILE_URL_g4WWY8T1T7OX80pWiH63hg